import React from 'react'

interface TickIconProps {
	fill?: string
}

const TickIcon: React.FC<TickIconProps> = ({ fill = '#030A7E' }) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="10" height="8" fill="none" viewBox="0 0 10 8">
		<path fill={fill} d="M2.893 5.93L1.026 4.064 0 5.09l2.463 2.463.003-.003.45.45 6.953-6.954L8.823 0l-5.93 5.93z" />
	</svg>
)

export default TickIcon
